// extracted by mini-css-extract-plugin
export default {"root":"xDT0I","icon":"_1AuTL","title":"_3zfvn","subtitle":"ndmBL","button":"_29hta"};